module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/avatar4-4f73272b00b44efed568b175ac253fd6.png";